class ImplantationsModule {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();
    }

    bindUI() {
        this.ui = {};
    }

    bindEvents() {
    }
}

export default ImplantationsModule;
